<template>
  <v-app id="app" dark>
    <div class="appContent">
      <TitleBar class="titleBar"/>
      <SocialMediaBar class="socialMediaBar"/>
    </div>
  </v-app>
</template>

<script>
import SocialMediaBar from "./components/SocialMediaBar.vue";
import TitleBar from "./components/TitleBar.vue";

export default {
  name: "app",
  components: {
    SocialMediaBar,
    TitleBar
  }
};
</script>

<style scoped>
#app {
  position: fixed;
  top: 0px;
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url("./assets/bg.jpg");
  background-attachment: fixed;
}

.appContent {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}

.titleBar {
  margin-top: 100px;
}

.socialMediaBar {
  position: absolute;
  top: 70%;
  width: 50%;
}

@media only screen and (max-width: 600px) {
  .socialMediaBar,
  .appContent {
    width: 80%;
  }
  .titleBar {
    margin-top: 30px;
  }
}

@media only screen and (max-height: 500px) {
  .titleBar {
    margin-top: 30px;
  }
}

@media only screen and (min-width: 600px) and (max-height: 500px) {
  .socialMediaBar {
    position: static;
    width: 100%;
  }
}
</style>
